import React, { PureComponent } from "react";
import Select, { Creatable } from "react-select";

import FrontierSlidersContainer from "containers/FrontierSliders/FrontierSliders";
import { FRONTIER_SLIDERS_VIEW } from "containers/FrontierSliders/FrontierSliders";

import ConditionListInput from "components/UnifiedProject/SelectData/ConditionListInput";
import UniqueIdColumnInput from "components/UnifiedProject/SelectData/UniqueIdColumnInput";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup, Icon } from "aible";

import styles from "./style.module.css";
import { isEnabled } from "utils/featureFlags";

export default class OptimizeBy extends PureComponent {
  constructor(props) {
    super(props);

    const optimizeBy = props.optimizeBy;

    const retRecommendations = this.getSyncedRecommendations([], optimizeBy);

    this.state = {
      recommendations: retRecommendations,
      isAllSubgroups: true
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { optimizeBy } = this.props;
    const { recommendations } = this.state;

    if (this.getNeedsRecommendationSync(recommendations, optimizeBy)) {
      const newRecommendations = this.getSyncedRecommendations(recommendations, optimizeBy);

      this.setState({ recommendations: newRecommendations });
    }
  }

  getNeedsRecommendationSync(recommendations, optimizeBy = {}) {
    return !Object.keys(optimizeBy).every((rId) => {
      const currOptimizeBy = optimizeBy[rId];
      if (this.checkOptimizeByHasData(currOptimizeBy)) {
        return recommendations && recommendations.find((recId) => Number(recId) === Number(rId));
      }

      return true;
    });
  }

  checkOptimizeByHasData(optimizeBy) {
    return (
      optimizeBy &&
      (optimizeBy.optimizeBy !== undefined ||
        // optimizeBy.optimizeByCount !== undefined ||
        optimizeBy.optimizeGoal !== undefined)
    );
  }

  getSyncedRecommendations(recommendations, optimizeBy) {
    const retRecommendations = recommendations ? [...recommendations] : [];

    optimizeBy &&
      Object.keys(optimizeBy).forEach((rId) => {
        const currOptBy = optimizeBy[rId];

        if (this.checkOptimizeByHasData(currOptBy)) {
          if (!retRecommendations.find((e) => Number(e) === Number(rId))) {
            const targetIndex = retRecommendations.findIndex((e) => !e);
            if (targetIndex >= 0) {
              retRecommendations.splice(targetIndex, 1, Number(rId));
            } else {
              retRecommendations.push(Number(rId));
            }
          }
        }
      });

    return retRecommendations;
  }

  getSuccessString() {
    const { outcome, success } = this.props;

    const successString = outcome
      ? outcome + ": " + (Array.isArray(success) ? success.join(", ") : success)
      : undefined;

    return successString;
  }

  getSubgroupOptions(selectionIndex, runId, showAll) {
    const { modelGroups } = this.props;
    const { recommendations } = this.state;

    const options =
      modelGroups && modelGroups.drilldownValues
        ? modelGroups.drilldownValues
            .map((drilldown, index, drilldownArray) => {
              if (drilldown.value === "Overall" && drilldownArray.length > 1) {
                return;
              } else {
                return {
                  value: Number(drilldown.runId),
                  label: drilldown.label
                };
              }
            })
            .filter((elem) => elem)
        : [];

    return runId !== undefined
      ? options.find((o) => Number(o.value) === Number(runId)) || null
      : showAll
        ? options
        : options.filter((o) => {
            return !(
              recommendations &&
              recommendations.find(
                (recRunId, index) => selectionIndex !== index && Number(recRunId) === Number(o.value)
              )
            );
          });
  }

  getOptimizeByValues(runId) {
    const { optimizeBy } = this.props;

    return optimizeBy && optimizeBy[runId];
  }

  handleSubgroupChange(selectionIndex, subgroupRunId) {
    const { recommendations } = this.state;

    if (recommendations && selectionIndex !== undefined) {
      const oldRunId = recommendations[selectionIndex];

      if (Number(oldRunId) === Number(subgroupRunId)) {
        return;
      }

      const oldOptimizeBy = this.getOptimizeByValues(oldRunId);

      if (oldOptimizeBy) {
        if (oldOptimizeBy) {
          this.handleUpdateProjectOptimizeBy(subgroupRunId, oldOptimizeBy.optimizeBy);
          this.handleUpdateProjectOptimizeGoal(subgroupRunId, oldOptimizeBy.optimizeGoal);
          // this.handleUpdateProjectOptimizeByCount(
          //   subgroupRunId,
          //   oldOptimizeBy.optimizeByCount
          // );
        }

        this.handleDeleteOptimizeBy(oldRunId);
      }
    }

    let retRecommendations = [subgroupRunId];
    if (selectionIndex !== undefined) {
      retRecommendations = [...recommendations];
      retRecommendations[selectionIndex] = subgroupRunId;
    }

    return this.setState({ recommendations: retRecommendations });
  }

  handleUpdateProjectOptimizeBy(runId, value) {
    const { updateProjectOptimizeBy, onClick } = this.props;
    const retRunId = runId;

    if (onClick) {
      onClick();
    }

    return updateProjectOptimizeBy(retRunId, value);
  }

  handleUpdateProjectOptimizeGoal(runId, value) {
    const { updateProjectOptimizeGoal, onClick } = this.props;
    const retRunId = runId;

    if (onClick) {
      onClick();
    }

    return updateProjectOptimizeGoal(retRunId, value);
  }

  // handleUpdateProjectOptimizeByCount(runId, value) {

  //   const { updateProjectOptimizeByCount, onClick } = this.props;
  //   const retRunId = runId;

  // if (onClick) {
  //   onClick();
  // }

  //   return updateProjectOptimizeByCount(retRunId, value);
  // }

  handleDeleteOptimizeBy(runId, selectionIndex) {
    const { deleteOptimizeBy, onClick } = this.props;
    const { recommendations } = this.state;

    if (selectionIndex !== undefined) {
      const retRecommendations = [...recommendations];
      retRecommendations.splice(selectionIndex, 1);
      this.setState({ recommendations: retRecommendations });
    }

    const retRunId = runId;

    if (onClick) {
      onClick();
    }

    return deleteOptimizeBy(retRunId);
  }

  renderOptimizeBySelection(runId, selectionIndex) {
    const currOptimizeBy = this.getOptimizeByValues(runId) || {};
    const successString = this.getSuccessString();
    const retSelectionIndex = selectionIndex;

    const currSubgroup = this.getSubgroupOptions(retSelectionIndex, runId);

    const allSubgroups = this.getSubgroupOptions(undefined, undefined, true);

    const hasSubgroups = allSubgroups && allSubgroups.length > 1;

    return (
      <div className={styles.optimizeBySelectionWrapper} key={"OptimizeBySelection" + runId + selectionIndex}>
        <Button onClick={() => this.handleDeleteOptimizeBy(runId, selectionIndex)}>
          <FontAwesomeIcon icon={faTrash} />
        </Button>
        <div className={styles.optimizeBySelectionContentWrapper}>
          <div className={styles.optimizeBySelectionContent}>
            {hasSubgroups ? (
              <React.Fragment>
                <div className={styles.optimizeBySelectionSelect}>
                  <Select
                    value={this.getSubgroupOptions(retSelectionIndex, runId)}
                    options={this.getSubgroupOptions(retSelectionIndex)}
                    onChange={(option) => this.handleSubgroupChange(retSelectionIndex, option && option.value)}
                  />
                </div>
                <div className={styles.optimizeBySelectionText}>{"display"}</div>
              </React.Fragment>
            ) : (
              <div className={styles.optimizeBySelectionText} style={{ marginLeft: "0px" }}>
                {"Display"}
              </div>
            )}
            <div className={styles.optimizeBySelectionSelect}>
              <Select
                value={(typeof currOptimizeBy.optimizeBy === "string"
                  ? [currOptimizeBy.optimizeBy]
                  : (currOptimizeBy.optimizeBy ?? [])
                )
                  .map((v) => (currOptimizeBy.optimizeByOptions ?? []).find(({ value }) => v === value))
                  .filter((v) => v !== undefined)}
                options={currOptimizeBy.optimizeByOptions}
                onChange={(options) =>
                  this.handleUpdateProjectOptimizeBy(
                    runId,
                    options.slice(0, 3).map((o) => o.value)
                  )
                }
                placeholder={!currSubgroup ? "Select Subgroup" : undefined}
                isDisabled={!currSubgroup}
                isMulti
              />
            </div>
            <div className={styles.optimizeBySelectionText}>{"that"}</div>
            <div className={styles.optimizeBySelectionSelect}>
              <Select
                value={
                  (currOptimizeBy.optimizeGoalOptions &&
                    currOptimizeBy.optimizeGoalOptions.find((o) => o.value === currOptimizeBy.optimizeGoal)) ||
                  null
                }
                options={currOptimizeBy.optimizeGoalOptions}
                onChange={(option) => this.handleUpdateProjectOptimizeGoal(runId, option && option.value)}
                isDisabled={!currSubgroup}
              />
            </div>
            <div className={styles.optimizeBySelectionText}>
              {"the likelihood of "}
              <strong>{successString}</strong>
            </div>
          </div>
          {/* <div className={styles.optimizeBySelectionContent}>
            <div className={styles.optimizeBySelectionText}>
              {"Show the top"}
            </div>
            <div className={styles.optimizeBySelectionSelect}>
              <Select
                value={
                  currOptimizeBy.optimizeByCountOptions &&
                  currOptimizeBy.optimizeByCountOptions.find(
                    (o) => o.value === currOptimizeBy.optimizeByCount
                  )
                }
                options={currOptimizeBy.optimizeByCountOptions}
                onChange={(option) =>
                  this.handleUpdateProjectOptimizeByCount(
                    runId,
                    option && option.value
                  )
                }
                isDisabled={!currSubgroup}
              />
            </div>
            <div className={styles.optimizeBySelectionText}>
              {"values that optimize "}
              <strong>{successString}</strong>
            </div>
          </div> */}
        </div>
      </div>
    );
  }

  handleAddRecommendation() {
    const { optimizeBy } = this.props;
    const { recommendations } = this.state;

    let retRecommendations = [...recommendations];
    const remainingOptions = this.getSubgroupOptions();
    if (remainingOptions.length === 1) {
      retRecommendations.push(
        remainingOptions[0] && remainingOptions[0].value !== undefined ? remainingOptions[0].value : null
      );
    } else {
      retRecommendations.push(null);
    }
    this.setState({ recommendations: retRecommendations });
  }

  renderOptimizeBy() {
    const { optimizeBy } = this.props;
    const { recommendations } = this.state;

    return (
      <div className={styles.optimizeByWrapper}>
        {recommendations && recommendations.map((runId, index) => this.renderOptimizeBySelection(runId, index))}
        {!recommendations || recommendations.length < Object.keys(optimizeBy).length ? (
          <Button
            onClick={() => {
              return this.handleAddRecommendation();
            }}
          >
            {"Add Recommendation"}
          </Button>
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  }

  render() {
    const { updateProjectOptimizeBy, deleteOptimizeBy, optimizeBy, modelGroups, outcome, success, setupLabels } =
      this.props;

    const successString = this.getSuccessString();

    return (
      <div style={{ marginBottom: "40px" }}>
        <div className={styles.deployHeader}>{"Prediction Optimization Recommendations"}</div>
        <div className={styles.deploySubHeader}>
          {
            "Do you want users to see and test how different behaviors (e.g. discount level or promotional offers) will impact the "
          }
          <strong>{successString ? successString + " " : ""}</strong>
          {"prediction for " + setupLabels.notPursuedTransactionLabel + "?"}
          <strong>{" Maximum of three fields allowed."}</strong>
        </div>
        {this.renderOptimizeBy()}
      </div>
    );
  }
}
